import { Directive, ElementRef, HostListener, Input, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: '[appTruncateText]',
})
export class TruncateTextDirective implements OnInit {
  @Input() fullText: string = ''; // ✅ Fix: Define fullText separately
  @Input() maxLength: number = 50;
  @Input() minScreenWidth: number = 768;
  @Input() completeWords: boolean = false;
  @Input() ellipsis: string = '...';

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.updateText();
  }

  @HostListener('window:resize')
  onResize() {
    this.updateText();
  }

  private updateText() {
    const screenWidth = window.innerWidth;
    let textToShow = this.fullText; // ✅ Fix: Use fullText explicitly

    if (screenWidth <= this.minScreenWidth) {
      if (this.completeWords) {
        const truncated = textToShow.substring(0, this.maxLength);
        const lastSpace = truncated.lastIndexOf(' ');
        textToShow = lastSpace > 0 ? truncated.substring(0, lastSpace) + this.ellipsis : truncated + this.ellipsis;
      } else {
        textToShow =
          textToShow.length > this.maxLength ? textToShow.substring(0, this.maxLength) + this.ellipsis : textToShow;
      }
    }

    this.renderer.setProperty(this.el.nativeElement, 'textContent', textToShow);
  }
}
